module.exports = __webpack_public_path__ + "static/img/strong_16.7fb4fafb.png";